import { tickerItems } from '@/mocks/home';

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="border-y border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-7xl items-center px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 border-r border-background-300 py-3 pr-4 text-xs font-bold text-primary-600 md:pr-6 md:text-sm">
          <i className="ri-flashlight-fill text-base" />
          快讯流
        </span>
        <div className="relative flex-1 overflow-hidden py-3 pl-4 md:pl-6">
          <div className="flex w-max animate-marquee items-center gap-10">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-700 md:text-sm"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}